import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Instagram, Facebook, Youtube } from "lucide-react";
import { useSettings } from "../../lib/settings";

export default function Footer() {
  const { settings } = useSettings();
  const s = settings;
  return (
    <footer data-testid="site-footer" className="mt-32 border-t border-white/10 bg-[#0a0a0d]">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div>
          <div className="font-display text-4xl tracking-tight">{s.business_name?.toUpperCase() || "PICK AUTO"}</div>
          <div className="overline mt-1">{s.tagline}</div>
          <p className="text-white/60 text-sm mt-6 max-w-xs leading-relaxed">
            A locally-owned used car dealership on Gallatin Pike, serving the greater Nashville area.
          </p>
        </div>
        <div>
          <div className="overline mb-4">Explore</div>
          <ul className="space-y-3 text-white/70 text-sm">
            <li><Link to="/inventory" className="hover:text-white">Inventory</Link></li>
            <li><Link to="/finance" className="hover:text-white">Finance</Link></li>
            <li><Link to="/trade-in" className="hover:text-white">Trade-In</Link></li>
            <li><Link to="/about" className="hover:text-white">About</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-4">Visit</div>
          <ul className="space-y-3 text-white/70 text-sm">
            <li className="flex items-start gap-2" data-testid="footer-address">
              <MapPin size={14} className="mt-1" />
              <span>{s.address_line1}, {s.address_line2}</span>
            </li>
            <li className="flex items-center gap-2" data-testid="footer-phone"><Phone size={14} /> {s.phone}</li>
            <li className="flex items-center gap-2" data-testid="footer-email"><Mail size={14} /> {s.email}</li>
          </ul>
        </div>
        <div>
          <div className="overline mb-4">Hours</div>
          <ul className="space-y-2 text-white/70 text-sm" data-testid="footer-hours">
            <li>{s.hours_weekday}</li>
            <li>{s.hours_sunday}</li>
          </ul>
          <div className="flex gap-3 mt-6">
            <a href="#" aria-label="Instagram" className="w-9 h-9 rounded-full border border-white/10 hover:border-[var(--primary)] flex items-center justify-center transition-colors"><Instagram size={14} /></a>
            <a href="#" aria-label="Facebook" className="w-9 h-9 rounded-full border border-white/10 hover:border-[var(--primary)] flex items-center justify-center transition-colors"><Facebook size={14} /></a>
            <a href="#" aria-label="YouTube" className="w-9 h-9 rounded-full border border-white/10 hover:border-[var(--primary)] flex items-center justify-center transition-colors"><Youtube size={14} /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1500px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <div>© {new Date().getFullYear()} {s.business_name}. All rights reserved.</div>
          <div className="flex gap-4">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
            <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white opacity-40 hover:opacity-100">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
